const t = {
  name: "WarningFilled",
  dimensions: { width: 22, height: 21 },
  content: `
        <g >
            <path d="M19 19.5H3C1.9 19.5 1 18.6 1 17.5C1 16.85 1.18 16.2 1.51 15.64L9.49 2.36C9.8 1.83 10.38 1.5 11 1.5C11.62 1.5 12.2 1.83 12.51 2.36L20.48 15.65C20.82 16.2 21 16.85 21 17.5C21 18.6 20.1 19.5 19 19.5Z" fill="currentColor" stroke="currentColor" stroke-width="2" stroke-miterlimit="10" stroke-linejoin="round"/>
            <path d="M11 7.5V11.5" stroke="white" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M11 17C11.8284 17 12.5 16.3284 12.5 15.5C12.5 14.6716 11.8284 14 11 14C10.1716 14 9.5 14.6716 9.5 15.5C9.5 16.3284 10.1716 17 11 17Z" fill="white"/>
        </g>
  `
};
export {
  t as WarningFilled
};
